import * as api from 'app/resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchInquiryReasonsDictionaryRequest = () => ({
  type: actionTypes.FETCH_INQUIRY_REASONS_DICTIONARY_REQUEST,
});

export const fetchInquiryReasonsDictionarySuccess = (dictionary) => ({
  type: actionTypes.FETCH_INQUIRY_REASONS_DICTIONARY_SUCCESS,
  dictionary,
});

export const fetchInquiryReasonsDictionaryFailure = () => ({
  type: actionTypes.FETCH_INQUIRY_REASONS_DICTIONARY_FAILURE,
});

export const fetchInquiryReasonsDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchInquiryReasonsDictionaryRequest());
    const dictionary = await api.fetchInquiryReasonsDictionary(locale);
    dispatch(fetchInquiryReasonsDictionarySuccess(dictionary));
  } catch (error) {
    console.error('FETCH_INQUIRY_REASONS_DICTIONARY', error);
    dispatch(fetchInquiryReasonsDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/inquiry-reasons-dictionary.actions.js